import { Component, inject } from '@angular/core';
import { KeycloakService } from '../../services/keycloak.service';
import { ISidebarNavItem } from './sidebar.interface';
import { NavSidebar } from '../nav-sidebar/nav-sidebar';
import { IconSvg } from '../icon-svg/icon-svg';

@Component({
  selector: 'app-sidebar',
  imports: [NavSidebar, IconSvg],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar {
  private keycloakService = inject(KeycloakService);

  protected navItemsData: ISidebarNavItem[] = [
    {
      id: 1,
      name: 'Signalements',
      iconName: 'flag',
      pagePath: '/signalements'
    }
  ];

  protected settingItemsData: ISidebarNavItem[] = [
    {
      id: 2,
      name: 'Paramètre',
      iconName: 'parameter',
      pagePath: '/parametre'
    },
  ];

  protected logout(): void {
    this.keycloakService.logout();
  }
}
